import {NavLink as Link} from 'react-router-dom';
import Loading from './../misc/Loading';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import React from 'react';
import TagsInput from 'react-tagsinput';
import update from 'immutability-helper';

// Style
import 'react-tagsinput/react-tagsinput.css';

class VariantGroupComponent extends React.Component {
  constructor(props) {
    super(props);

    this.handlePublish = this.handlePublish.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleTagsChange = this.handleTagsChange.bind(this);
    this.handleAssetChange = this.handleAssetChange.bind(this);
  }

  /* Handle submit */
  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handlePublish(e) {
    e.preventDefault();
    this.props.onPublish();
  }

  handleUnpublish(e) {
    e.preventDefault();
    this.props.onUnpublish();
  }

  handleSave(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handleFieldChange(e) {
    const newData = {
      variantGroup: {}
    };

    newData.variantGroup[e.target.name] = {
      $set: e.target.value
    };

    const props = update(this.props, newData);

    this.props.onChange(props);
  }

  handleTagsChange(tagsArray) {
    const newData = {
      variantGroup: {}
    };

    newData.variantGroup.tags = {
      $set: tagsArray
    };

    const props = update(this.props, newData);

    this.props.onChange(props);
  }

  handleAssetChange(name, asset) {
    const change = {
      variantGroup: {}
    };

    change.variantGroup[name] = {
      $set: asset
    };

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  render() {
    if (this.props.variantGroup) {
      const g = this.props.variantGroup;
      // console.log(g);

      return (
        <section className="mf-model">
          <ol className="breadcrumb mf-margin-top-20">
            <li><Link to="/">Forsiden</Link></li>
            <li><Link to="/nybilinformasjon/">Nybilinformasjon</Link></li>
            <li>
              <Link to={`/modeller/${this.props.model.make.id}`}>{this.props.model.make.name}</Link>
            </li>
            <li>
              <Link to={`/modeller/${this.props.model.make.id}/modell/${this.props.model.id}`}>{this.props.model.name}</Link>
            </li>
            <li className="active">{g.name}</li>
          </ol>

          <form onSubmit={this.handleSubmit}>
            <div className="page-header">
              <div className="row">
                <div className="col-xs-12 col-sm-8">
                  <h1>{g.name} <PublishStatusDot entry={g} /><br/>
                    <small>Variantgruppe</small></h1>
                </div>

                <div className="col-xs-12 col-sm-4 text-right mf-padding-top-10">
                  {this.props.working &&
                    <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...&nbsp;</span>
                  }
                  {!g.archived &&
                    <button
                      type="submit"
                      className="btn btn-default"
                      disabled={!this.props.modified || this.props.working}
                    >
                      <span>Lagre endringer</span>
                    </button>
                  }
                  &nbsp;
                  <button
                    type="button"
                    className="btn btn-success"
                    disabled={g.archived || (g.published && !g.updated) || this.props.working || this.props.modified}
                    onClick={this.handlePublish}
                  >
                    <span>Publiser</span>
                  </button>
                  &nbsp;
                  <button
                    type="button"
                    className="btn btn-warning"
                    disabled={g.draft || this.props.working || this.props.modified}
                    onClick={this.handleUnpublish}
                  >
                    <span>Avpubliser</span>
                  </button>
                  &nbsp;
                  {!g.archived &&
                    <button
                      type="button"
                      className="btn btn-danger"
                      disabled={(this.props.working)}
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.onArchive();
                      }}
                    >
                      <span>Arkiver</span>
                    </button>
                  }
                  {g.archived &&
                    <button
                      type="button"
                      className="btn btn-danger"
                      disabled={(this.props.working)}
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.onUnArchive();
                      }}
                    >
                      <span>Gjenopprett</span>
                    </button>
                  }
                </div>
              </div>
            </div>

            {/* Display any error message: */}
            {this.props.error &&
              <div className="alert alert-danger">
                {this.props.error}
              </div>
            }

            <div className="row">
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Navn <em className="small text-muted">(Påkrevet)</em></label>
                  <input type="text" className="form-control" name="name" disabled={g.archived || this.props.working} defaultValue={g.name} onChange={this.handleFieldChange} required />
                </div>
              </div>
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Nøkkelord for gruppen (valgfri)</label>
                  {/* <input type="text" className="form-control" name="tags" ref="tags" defaultValue={g.tags} onChange={this.handleFieldChange}/>*/}
                  <TagsInput
                    addOnBlur={true}
                    value={g.tags}
                    disabled={g.archived || this.props.working}
                    onChange={this.handleTagsChange}
                    className="react-tagsinput form-control"
                    addKeys={[9, 13, 188]}
                    inputProps={{placeholder: 'Ny tag'}}
                  />
                </div>
              </div>
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Merke</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="modelGroup" defaultValue={this.props.model.make.name} disabled />
                    <div className="input-group-addon">Data fra Axapta</div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Modell</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="modelGroup" defaultValue={this.props.model.name} disabled />
                    <div className="input-group-addon">Data fra Axapta</div>
                  </div>
                </div>
                {this.props.model.make.slug === 'hongqi' && <>
                  <div className="form-group">
                    <label>Deaktivert tekst</label>
                    <input type="text" className="form-control" disabled={this.props.working || g.archived} name="deactivatedText" defaultValue={g.deactivatedText} onChange={this.handleFieldChange} />
                    <span className="help-block">
                      Eks. &quot;Midlertidig utsolgt&quot;<br />Om tekst er satt vil dette vises istedenfor pris. Gruppen vil være synlig, men deaktivert i konfiguratoren.
                    </span>
                  </div>
                </>}
              </div>
            </div>
          </form>
        </section>
      );
    }
    return (
      <Loading title="Variantgruppe" text="Laster variantgruppe" />
    );
  }
}

VariantGroupComponent.defaultProps = {
  variantGroup: null,
  modified: null,
  working: null,
  onChange: () => {},
  onSave: () => {},
  onPublish: () => {}
};

export default VariantGroupComponent;
